import i18next, { type i18n } from 'i18next';
import { initReactI18next, useTranslation } from 'react-i18next';

import { resolveLanguage, resources, type SupportedLanguage } from '../i18n';

/**
 * Creates an isolated i18next instance for one language.
 *
 * A fresh instance per app (and per test) keeps state from leaking between renders.
 * It is initialized synchronously because the catalogue is bundled, so the first
 * render already has its texts.
 */
export function createI18n(language: SupportedLanguage): i18n {
  const instance = i18next.createInstance();
  void instance.use(initReactI18next).init({
    resources,
    lng: language,
    fallbackLng: 'en',
    initAsync: false,
    // React already escapes rendered text.
    interpolation: { escapeValue: false },
  });
  return instance;
}

/** The current UI language, narrowed to a supported one (for `Intl` formatting). */
export function useLanguage(): SupportedLanguage {
  const { i18n: instance } = useTranslation();
  return resolveLanguage(instance.language);
}
